
import { Options, Vue } from 'vue-class-component';
import AppTile from './AppTile.vue';
import { Prop } from 'vue-property-decorator';
import api from '@/shared/api';

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
function isObject(item: any) {
    return item && typeof item === 'object' && !Array.isArray(item);
}

/**
 * Deep merge two objects.
 * @param target
 * @param sources
 */
function mergeDeep(target: any, ...sources: any): any {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return mergeDeep(target, ...sources);
}

@Options({
    components: {
        AppTile,
    },
})
export default class ExpiredAssetsSettings extends Vue {
    @Prop()
    protected app: undefined | any = undefined;

    protected ready = false;

    protected actions = {
        updateVisibility: {
            enabled: false,
            userGroup: null,
        },
        updateDescription: {
            enabled: false,
            content: '[EXPIRED] ',
            place: 'prefix',
        },
        updateName: {
            enabled: false,
            content: '[EXPIRED] ',
            place: 'prefix',
        },
    };

    protected userGroups = [];

    async created() {
        this.userGroups = await api.getSprinklrUserGroups(this.app.id);

        this.actions = mergeDeep(
            this.actions,
            this.app.settings && this.app.settings.actions ? this.app.settings.actions : {},
        );

        this.ready = true;
    }

    public getSettings() {
        return mergeDeep(this.app.settings ?? {}, { actions: this.actions });
    }
}
